export const entranceBilling = {
	tabs: {
		pageTabs: {
			boxOffice: "Facturación",
			soldEntrances: "Entradas vendidas",
			employeeReport: "Entradas por empleado",
		},
		boxOfficeBilling: {
			label: "Facturación de taquilla",
			value: "valor",
			revenue: "ingreso",
			percentage: "porcentaje",
			quantity: "cantidad",
			filename: "facturacion_taquilla",
		},
		soldEntrances: {
			label: "Total de entradas vendidas",
			tabs: {
				total: "Total",
				clients: "Clientes por entrada",
			},
			columns: {
				name: "Nombre",
				count: "Unidades vendidas",
				averageValue: "Precio promedio",
				totalValue: "Total",
			},
			total: "Ingreso Total",
			sheet: {
				title: "Entradas vendidas",
				fileName: "entradas_vendidas",
				name: "Nombre",
				average: "Valor promedio",
				count: "Cantidad",
				totalValue: "Precio",
			},
			filter: "Filtrar por hora",
			since: "De",
			until: "Hasta",
			clientsReport: {
				title: "Listado de clientes por entrada vendida",
				filterLabel: "Filtrar por entrada vendida",
				filterPlaceholder: "Agregar filtros por entrada",
				clients: "Clientes",
				entranceValue: "Valor de la entrada",
				consumpion: "Consumo",
				total: "Total",
				name: "Nombre",
				document: "Documento",
				entrance: "Entrada",
				checkin: "Check-in",
				checkout: "Checkout",
				fileName: "clientes-por-entrada-vendida_{{date}}",
			},
		},
		entranceReport: {
			label: "Entradas vendidas por empleados",
			filename: "entradas-vendidas-por-empleado",
			columns: {
				name: "Nombre",
				count: "Cantidad",
				unitValue: "Valor unitario",
				subtotal: "Subtotal",
				discountValue: "Descuentos",
				totalValue: "Valor total",
				entrance: "Entrada",
			},
			sheet: {
				title: "Entradas",
				fileName: "entradas",
				name: "Nombre",
				count: "Cantidad",
				unitValue: "Valor unitario",
				subtotal: "Subtotal",
				discountValue: "Descuentos",
				totalValue: "Valor total",
			},
			total: "Total",
			totalCategory: "Total ({{category}})",
		},
	},
};
